import { render, staticRenderFns } from "./Bidrecord.vue?vue&type=template&id=07de7aa6&scoped=true&"
import script from "./Bidrecord.vue?vue&type=script&lang=js&"
export * from "./Bidrecord.vue?vue&type=script&lang=js&"
import style0 from "./Bidrecord.vue?vue&type=style&index=0&id=07de7aa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de7aa6",
  null
  
)

export default component.exports